import AllhomesAgencyProfile from './allhomes-agency-profile-graphql';
export default AllhomesAgencyProfile;